var form = {
	init: function(){

	},
	nav: function(){
		$("#btn_submit input").on("click", function(){
			if( !$("#btn_submit").hasClass("sending") ){
				$("#btn_submit").addClass("sending");
			}
		});
		$("p.link_privacy input").off("change").on("change", function(){
			var isChecked = $(this).prop("checked");
			//console.log("changed")
			if(isChecked){
				$("#btn_submit").addClass("agree");
			}else{
				$("#btn_submit").removeClass("agree");
			}
		});
		//フォーム入力後のリダイレクト
		var redirectURL = '';
		redirectURL = location.pathname + "download/";
		//console.log(page.isPage, ":", redirectURL);
		if(!page.isFirst){
		//	console.log("form init");
			$( 'div.wpcf7 > form' ).each( function() {
				var $form = $( this );
				wpcf7.initForm( $form );
				if ( wpcf7.cached ) {
					wpcf7.refill( $form );
				}
			} );
		}
		
		if(page.isPage != "contact"){
			var wpcf7Elm = document.querySelector( '.wpcf7' );
		//	console.log(redirectURL)
			wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
				location.href = redirectURL;
				//page.changeURL(redirectURL);
			}, false );
		}else{
			var wpcf7Elm = document.querySelector( '.wpcf7' );
			
			wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
				window.scrollTo(0,0);
				$("#content.contact").addClass("complete");
			}, false );
		}
		wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
			common.scrollToPosition(0);
			if( $("#btn_submit").hasClass("sending") ){
				$("#btn_submit").removeClass("sending");
			}
		}, false );

	},
	contact: function(){
		this.nav();
		$('input[type=file]').change(function() {
			var file = $(this).prop('files')[0];
			// / 種類:'  file.type
			$(".txt_selected").html(file.name);
		});
	},
	checkRadio: function(){
		this.nav();
		$("form input").each(function(i){
			var type = $(this).attr("type");
			if(type === "radio"){
				$(this).closest("dd").addClass("radio");
				$(this).after('<span class="icon_radio"></span>');
			}
		});
	}
}